import { render, staticRenderFns } from "./OrdersHistory.html?vue&type=template&id=9711d90c&scoped=true&"
import script from "./OrdersHistory.js?vue&type=script&lang=js&"
export * from "./OrdersHistory.js?vue&type=script&lang=js&"
import style0 from "./orders-history.scss?vue&type=style&index=0&id=9711d90c&prod&scoped=true&lang=scss&"
import style1 from "./orders-history.scss?vue&type=style&index=1&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9711d90c",
  null
  
)

export default component.exports